export
default {
		common:
		{
		    langEn: 'English',     
		    langZh: '简体中文',       
		    langFt: '繁體中文',      
		    langMl: 'Bahasa Melayu', 
		    langYn: 'Tiếng Việt',   
		    langJa: '日本語',         
		    langKr: '한국어',       
		    langFa: 'Français',    
		    langTr: 'Türkçe',     
		    langYin: 'Bahasa Indonesia', 
		    langEs: 'Español'   
		},
		"home": {
			"h1": "MetaMask 암호화폐",
			"h1B": "MetaMask 암호화폐 뱅크",
			"h1C": "DeFi 지갑 암호화폐",
			"h1D": "Coinbase 암호화폐 뱅크",
			"h1E": "MetaMask 저축 은행",
			"h1F": "USDT 디지털 통화 뱅크",
			"h2": "친구 초대",
			"h3": "출금 계좌",
			"h4": "저축 참여",
			"h4B": "암호화폐 입금",
			"h4C": "디지털 화폐 입금",
			"h5": "추천 자산 관리",
			"h5B": "초 단위 계약 거래",
			"h6": "사용자 풀",
			"h7": "USDT 계좌",
			"h8": "총 수익",
			"h9": "유효 노드",
			"h10": "참가자",
			"h11": "수익",
			"h12": "수익 기록",
			"h13": "주소",
			"h14": "번호",
			"h15": "자주 묻는 질문",
			"h16": "참여 방법은?",
			"h17": "귀하께서 USDT 지갑 저축에 참여하시려면 플랫폼 이용 규칙을 준수하고, 플랫폼 결정을 엄격히 이행하며, 리스크 부서의 감독을 받아야 합니다. 그러면 자동으로 입금 권한이 부여됩니다. 참여를 환영합니다.",
			"h17B": "귀하께서 USDT 지갑 저축에 참여하시려면 플랫폼 이용 규칙을 준수하고, 플랫폼 결정을 엄격히 이행하며, 리스크 부서의 감독을 받아야 합니다. 그러면 자동으로 입금 권한이 부여됩니다. 참여를 환영합니다.",
			"h18": "출금 절차",
			"h19": "일일 수익은 자동으로 계좌 잔액에 적립됩니다. USDT 출금 성공 후 USDT 지갑에 자동 반영됩니다.",
			"h19B": "'출금' 옵션을 클릭하세요. USDT로 직접 출금하려면 정확한 지갑 주소를 입력하세요.\n해당 국가의 통화로 출금하려면 해당 국가의 은행 카드를 선택하고 은행 카드 정보를 입력하세요.\n필수 정보를 입력한 후 출금 금액을 입력하고 계좌에 입금될 때까지 1~24시간 정도 기다려 주세요.",
			"h20": "수익은 어떻게 계산되나요?",
			"h21B": "성공적으로 등록한 후, 귀하의 저축 계좌는 수익 계산을 시작합니다\n저축액 1$-500$ 이하의 경우 0.5% 이자를 받을 수 있습니다\n저축액 500$ 이상은 0.6% 이자를 받을 수 있습니다\n저축액 1000$ 이상은 0.7% 이자를 받을 수 있습니다\n저축액 2000$ 이상은 0.8% 이자를 받을 수 있습니다\n저축액 3000$ 이상은 0.9% 이자를 받을 수 있습니다\n저축액 5000$ 이상은 1% 이자를 받을 수 있습니다",
			"h21": "참여 후, 저축 계약이 수익 계산을 시작합니다.",
			"h22": "저축 수익의 원천은?",
			"h23": "참여 후 저축 계약이 효력을 발생합니다. 이자는 1일 4회(00:00, 06:00, 12:00, 18:00)에 정산됩니다. 자금은 에스크로 되며, 플랫폼이 보안을 책임집니다. 규칙을 준수하고, 문제 발생 시 고객센터로 문의하세요.",
			"h23B": "참여 후 저축 계약이 효력을 발생합니다. 이자는 1일 4회(00:00, 06:00, 12:00, 18:00)에 정산됩니다. 자금은 에스크로 되며, 플랫폼이 보안을 책임집니다. 규칙을 준수하고, 문제 발생 시 고객센터로 문의하세요.",
			"h24": "보너스는 얼마인가요?",
			"h25": "친구를 초대할 수 있습니다. 초대한 친구가 참여하면 첫 입금액의 20% 추천 보상과 이후 수익의 10% 영구 수수료를 받습니다. 초대 링크는 홈페이지 오른쪽 상단에 있습니다.",
			"h25B": "이 플랫폼을 친구와 공유할 수 있습니다. 친구가 참여하면 첫 입금액의 20% 추천 보상과 이후 수익의 10% 영구 수수료를 받습니다. 공유 링크는 홈페이지 오른쪽 상단에 있습니다.",
			"h26": "계좌",
			"h27": "총 수입",
			"h88": "플랫폼 배경",
			"h89": "USDT\n설립: 2008년\n본사: 미국 뉴욕\n사업: 로보어드바이저 및 핀테크, 자동화 투자 포트폴리오 및 현금 관리\n규제: SEC 규제, FINRA 회원\n규모: 자산 운용액 400억 달러 이상\n고객: 개인·법인 80만 명 이상",
			"h90": "플랫폼 강점",
			"h91": "✔️ 미국 최초 로보어드바이저 중 하나, 경험 풍부\n✔️ 현대 포트폴리오 이론 기반 위험 분산\n✔️ 세금 최적화 기능\n✔️ 고이자 현금 계좌, 유동성 높음\n✔️ 완전 디지털 운영, 간단한 인터페이스",
			"h92": "이런 분께 적합",
			"h93": "★ 빈번한 거래 없이 장기 안정 투자를 원하는 분\n★ 자동 자산 관리로 번거로움을 줄이고 싶은 젊은 투자자\n★ 투자 + 고이자 저축 + 퇴직 계좌에 관심 있는 분\n★ 저비용으로 시장에 진입하려는 일반 투자자",
			"h94": "보너스는 얼마나 되나요?",
			"h95": "친구들과 플랫폼을 공유할 수 있습니다. 친구가 가입하면 첫 입금액의 20% 추천 보너스와 수익의 10% 추천 수수료를 받습니다. 공유 링크는 홈페이지 오른쪽 상단에 있습니다.",
			"h96": "복사",
			"h97": "초대 링크",
			"h98": "복사 성공",
			"h99": "복사 실패",
			"h28": "오늘 수익",
			"h29": "자산 관리 수익",
			"h30": "출금",
			"h31": "기록",
			"h32": "사용 가능 잔액",
			"h33": "출금 금액",
			"h34": "출금 금액 입력",
			"h35": "전체",
			"h36": "출금",
			"h37": "자주 묻는 질문",
			"h38": "보안 감사 보고서 있음",
			"h39": "파트너",
			"h40": "비즈니스 파트너",
			"h41": "은행 카드 번호 표시",
			"h42": "이전",
			"h43": "다음",
			"h44": "첫 번째 페이지입니다",
			"h45": "출금 금액을 입력해 주세요",
			"h46": "잔액 부족",
			"h47": "마지막 페이지입니다",
			"h48": "수입",
			"h49": "지출",
			"h50": "작업이 너무 잦습니다. 잠시 후 다시 시도해 주세요.",
			"h51": "감사 보고서",
			"h52": "예치하여 이자 받기",
			"h53": "주문 거래",
			"h54": "가입 보너스",
			"h55": "추천 보너스",
			"h56": "출금",
			"h57": "충전",
			"h58": "입금",
			"h59": "인출",
			"h60": "회사 소개",
			"h61": "MetaMask 뱅크를 지원해 주신 사용자 여러분께. 저축을 더 편리하게, 암호화폐(USDT, ETH, BTC) 송금으로 보너스 획득. 1000USDT 이상 입금 시 30USDT, 5000USDT 이상 시 200USDT, 10000USDT 이상 시 금액의 5% 보너스. (암호화폐 지갑 출금도 동일 적용)",
			"h61B": "Coinbase 뱅크를 지원해 주신 사용자 여러분께. 저축을 더 편리하게, 암호화폐(USDT, ETH, BTC) 송금으로 보너스 획득. 1000USDT 이상 입금 시 30USDT, 5000USDT 이상 시 200USDT, 10000USDT 이상 시 금액의 5% 보너스.",
			"h61C": "MetaMask 뱅크를 지원해 주신 사용자 여러분께. 저축을 더 편리하게, 암호화폐(USDT, ETH, BTC) 송금으로 보너스 획득. 1000USDT 이상 입금 시 30USDT, 5000USDT 이상 시 200USDT, 10000USDT 이상 시 금액의 5% 보너스.",
			"h61D": "USDT은 2017년부터 블록체인 자산에 대한 접근성을 높여 누구나, 어디에서나 더 큰 재정적 자유를 누릴 수 있도록 지원해 왔습니다."
		},
		"bankcard": {
			"b1": "은행 계좌",
			"b2": "금융 기관명",
			"b3": "금융 기관명 입력",
			"b4": "지점명",
			"b5": "지점명 입력",
			"b6": "지점 번호",
			"b7": "지점 번호 입력",
			"b8": "계좌번호 (일반)",
			"b9": "계좌번호 입력",
			"b10": "별명",
			"b11": "사용자명 입력",
			"b12": "예금주",
			"b13": "예금주 입력",
			"b14": "연결"
		},
		"usdt": {
			"u1": "내 주문",
			"u2": "매수",
			"u3": "계약 시간 선택:",
			"u4": "매수가:",
			"u5": "매수 금액 입력",
			"u6": "매수",
			"u7": "매도",
			"u8": "작업 성공",
			"u9": "최소",
			"u10": "초과",
			"u11": "금액이 더 커야 합니다",
			"u12": "금액이 더 작아야 합니다",
			"u13": "잔액이 수수료를 충당하기에 부족합니다",
			"u14": "만기 정산 완료",
			"u15": "현재 가격",
			"u17": "방향",
			"u19": "수수료"
		},
		"order": {
			"o0": "내 주문",
			"o1": "주문번호",
			"o2": "주문 유형",
			"o3": "매수 금액",
			"o4": "매도 금액",
			"o5": "결제 금액",
			"o6": "계약 시간",
			"o7": "주문 상태",
			"o8": "정산 상태",
			"o9": "정산 시간",
			"o10": "주문 시간",
			"o11": "매수",
			"o12": "매도",
			"o13": "매도 완료",
			"o14": "수익",
			"o15": "손실",
			"o16": "결제 완료",
			"o17": "손익분기점"
		},
		"recharge": {
			"r1": "충전 금액",
			"r2": "충전 금액",
			"r3": "충전 유형",
			"r4": "선택",
			"r5": "충전 주소",
			"r6": "송금 거래 ID",
			"r7": "송금 완료",
			"r8": "검토 중",
			"r9": "잘못된 입력",
			"r10": "결제 수단 선택",
			"r11": "最低 충전 금액은",
			"r12": "충전 상한 금액은",
			"r13": "금액을 입력해주세요",
			"r14": "결제 스크린샷 업로드",
			"r15": "결제 스크린샷을 업로드해 주세요",
			"r16": "제출 성공"
		},
		"rechargeDetails": {
			"r1": "충전 기록",
			"r2": "충전 금액",
			"r3": "검토 중",
			"r4": "충전 성공",
			"r5": "충전 실패"
		},
		new:{
			h70:"수량",
			h71:"유형",
			h72:"시간",
			h80:"법정화폐 출금",
			h81:"온라인 출금",
			h82:"출금 주소를 입력하세요",
			h83:"출금 수량을 입력하세요",
			h84:"출금 유형을 선택하세요",
			h85:"거래 정보",
			h86:"최소 출금 금액",
			h87:"수수료",
			h88:"예상 입금액",
			h89:"제출",
			h90:"내 은행카드",
			h91:"은행카드 변경",
			h910:"먼저 은행카드를 등록하세요",
			h911:"은행카드 등록",
			h92:"취소",
			h93:"확인",
			h94:"이름",
			h95:"가격",
			h96:"변동률",
			h97:"출금 금액이 올바르지 않습니다",
			h98:"더 보기",
			h99:"잔액 변동 기록",
			h60:"출금 성공",
			h61:"출금 실패",
			h62:"복사 성공",
			h63:"코인 종류",
			"h50": "PayPay 출금",
			"h51": "PayPay ID 입력",
			"h52": "전화번호 입력",
			"h53": "PayPay QR 코드 업로드",
			"h54": "채널 선택",
			"h55": "입금 네트워크",
			"h56": "출금 정보를 다시 확인하세요",
			  "h57": "PayPay ID",
			  "h58": "전화번호",
			  "h59": "계좌 변동 금액"
		},
		api:{
			"提现超过限制次数":"출금 횟수 제한을 초과했습니다",
			"两次提现间隔时间不得少于1小时":"출금 간격은 1시간 이상이어야 합니다",
			"提现超过限制次数":"출금 횟수 제한을 초과했습니다",
			"提现申请":"출금 신청",
			"提现金额未配置":"출금 금액이 설정되지 않았습니다",
			"禁止登录":"로그인 금지",
			"您存在多笔待处理提现订单":"처리 대기 중인 출금 주문이 여러 건 있습니다",
			"低于最低提现额度":"최소 출금 금액보다 적습니다",
			"提现超过限制":"출금 한도를 초과했습니다",
			"请先绑定提现账号":"먼저 출금 계좌를 등록하세요",
			"処理":"처리 중",
			"银行不存在":"은행이 존재하지 않습니다",
			"处理中":"처리 중",
			"订单交易":"주문 거래",
			"邀请奖励":"초대 보상",
			"秒合约订单结算":"초단기 계약 주문 정산",
			"获取火币行情失败":"Huobi 시세 불러오기 실패",
			"用户数据不存在":"사용자 데이터가 없습니다",
			"没有此账号":"해당 계정이 없습니다",
			"邀请码不存在":"초대 코드가 없습니다",
			"注册奖励":"가입 보상",
			"用户提现":"사용자 출금",
			"失败请重试":"실패했습니다. 다시 시도하세요",
			"请不要重复提交":"중복 제출하지 마세요",
			"用户名或密码错误":"아이디 또는 비밀번호가 잘못되었습니다",
			"密码不能为空":"비밀번호를 입력하세요",
			"用户名已存在":"이미 존재하는 아이디입니다",
			"用户名长度在4到12位之间":"아이디는 4~12자 사이여야 합니다",
			"密码格式为任意可见字符，长度在6~18之间":"비밀번호는 6~18자의 문자로 입력하세요",
			"密码错误次数太多":"비밀번호 오류 횟수가 너무 많습니다",
			"旧密码不正确":"기존 비밀번호가 올바르지 않습니다",
			"昵称不能为空":"닉네임을 입력하세요",
			"允许的最长字符为16":"최대 16자까지 입력 가능합니다",
			"图片不能为空":"이미지를 선택하세요",
			"用户不存在":"사용자가 존재하지 않습니다",
			"用户余额错误":"잔액 오류",
			"手机区号错误":"국가 번호가 올바르지 않습니다",
			"手机号长度最小5位数":"전화번호는 최소 5자리 이상이어야 합니다",
			"手机号不能为空":"전화번호를 입력하세요",
			"验证码错误":"인증 코드가 잘못되었습니다",
			"充值通道已关闭":"입금 채널이 닫혀 있습니다",
			"充值金额不正确":"입금 금액이 올바르지 않습니다",
			"最低充值额度100USDT":"최소 입금 금액은 100USDT입니다",
			"提现通道已关闭":"출금 채널이 닫혀 있습니다",
			"提现金额不正确":"출금 금액이 올바르지 않습니다",
			"请先绑定提现账号":"먼저 출금 계좌를 등록하세요",
			"低于最低提现额度":"최소 출금 금액보다 적습니다",
			"您已绑定过银行卡":"이미 은행카드를 등록했습니다",
			"两次提现间隔时间不得少于1小时":"출금 간격은 1시간 이상이어야 합니다",
			"登陆失败":"로그인 실패",
			"秒合约订单结算":"초단기 계약 주문 정산",
			"秒合约下单手续费":"초단기 계약 주문 수수료",
			"存币生息":"예치 이자",
			"提现":"출금",
			"充值":"입금",
			"上分": "오늘의 저축",
			"下分": "오늘의 인출액",
			"两次提现间隔时间不得少于1分钟":"두 번의 인출 간격은 최소 1분 이상이어야 합니다.",
			"赠送": "선물",
		},
		chat: {
			title: "온라인 고객센터",
			input: "메시지를 입력하세요...",
			send: "전송",
			empty: "메시지가 없습니다. 문의 내용을 남겨주세요",
			loginFirst: "먼저 지갑을 연결해 로그인하세요",
			sendFail: "전송에 실패했습니다",
			uploading: "이미지 업로드 중",
			uploadFail: "이미지 업로드에 실패했습니다"
		}
    }